/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import messages from 'src/shared/app/moderation/l10n/zmoderationL10n';
import { moderationPostNotificationTimeout } from 'src/shared/app/moderation/settings/moderationSettings';
import Notification from 'src/shared/app/notification/component/Notification';

import type { Notification as NotificationType } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  eventName: string,
  notification: NotificationType<>,
  handleDismiss: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const ModerationPostNotificationDumb = (props: Props): React.Node => {
  const { eventName, handleDismiss, intl } = props;

  // Elements

  return (
    <Notification
      timeout={moderationPostNotificationTimeout}
      withWarning
      handleDismiss={handleDismiss}
    >
      {intl.formatMessage(messages.moderationPostNotification, { eventName })}
    </Notification>
  );
};

export default compose(injectIntl)(ModerationPostNotificationDumb);
